(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inbike-homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanups = new Map();
    const init = (scope = document) => {
      scope.querySelectorAll('[data-aw26-riders]').forEach((root) => {
        if (root.dataset.ready === 'true') return;
        root.dataset.ready = 'true';
        const track = root.querySelector('[data-aw26-rider-track]');
        const prev = root.querySelector('[data-aw26-rider-prev]');
        const next = root.querySelector('[data-aw26-rider-next]');
        const update = () => {
          if (!track) return;
          const startInset = parseFloat(getComputedStyle(track).paddingLeft) || 0;
          prev.disabled = track.scrollLeft <= startInset + 4;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        };
        prev?.addEventListener('click', () => track?.scrollBy({ left: -track.clientWidth * .82, behavior: 'smooth' }));
        next?.addEventListener('click', () => track?.scrollBy({ left: track.clientWidth * .82, behavior: 'smooth' }));
        track?.addEventListener('scroll', update, { passive: true });
        const controller = new AbortController();
        const { signal } = controller;
        let activeButton = null;
        const resetButton = (button) => {
          button.classList.remove('is-playing');
          button.removeAttribute('aria-busy');
          button.setAttribute('aria-pressed', 'false');
          button.setAttribute('aria-label', button.dataset.playLabel);
          button.textContent = '▶';
        };
        const pauseAll = (except = null) => {
          root.querySelectorAll('video').forEach((video) => { if (video !== except) video.pause(); });
          if (activeButton && activeButton.parentElement.querySelector('video') !== except) {
            resetButton(activeButton);
            activeButton = null;
          }
        };
        root.querySelectorAll('[data-aw26-video-toggle]').forEach((button) => {
          button.addEventListener('click', async () => {
            const media = button.parentElement;
            let video = media.querySelector('video');
            if (activeButton === button) {
              pauseAll();
              return;
            }
            pauseAll();
            if (!video) {
              const template = media.querySelector('[data-aw26-video-template]');
              if (!template) return;
              media.insertBefore(template.content.cloneNode(true), button);
              video = media.querySelector('video');
              if (!video) return;
              video.addEventListener('playing', () => {
                if (activeButton !== button) { video.pause(); return; }
                media.classList.add('has-video-frame');
                button.removeAttribute('aria-busy');
                button.classList.add('is-playing');
                button.textContent = 'Ⅱ';
              }, { signal });
              video.addEventListener('pause', () => {
                if (activeButton === button) activeButton = null;
                resetButton(button);
              }, { signal });
              video.addEventListener('error', () => {
                if (activeButton === button) activeButton = null;
                resetButton(button);
                media.classList.remove('has-video-frame');
              }, { signal });
            }
            activeButton = button;
            button.setAttribute('aria-busy', 'true');
            button.setAttribute('aria-pressed', 'true');
            button.setAttribute('aria-label', button.dataset.pauseLabel);
            button.textContent = '…';
            try {
              if (video.error) video.load();
              await video.play();
            } catch {
              if (activeButton === button) {
                activeButton = null;
                resetButton(button);
              }
            }
          }, { signal });
        });
        const visibilityObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) {
              const button = entry.target.querySelector('[data-aw26-video-toggle]');
              if (button && activeButton === button) pauseAll();
            }
          }
        }, { threshold: 0 }) : null;
        root.querySelectorAll('.aw26-rider__media').forEach((media) => visibilityObserver?.observe(media));
        document.addEventListener('visibilitychange', () => { if (document.hidden) pauseAll(); }, { signal });
        cleanups.set(root, () => {
          pauseAll();
          controller.abort();
          visibilityObserver?.disconnect();
          root.dataset.ready = 'false';
        });
        update();
      });
    };
    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      for (const [root, cleanup] of cleanups) {
        if (event.target.contains(root)) { cleanup(); cleanups.delete(root); }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
